import React from 'react';
import { css, keyframes } from '@emotion/core';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const spin = keyframes`
  0% { transform:rotate(0deg); }
  100% { transform:rotate(360deg); }
`;

export interface SavingSpinnerProps {
  size?: React.ReactText;
  color?: string;
}

const SavingSpinner: React.FC<SavingSpinnerProps> = ({ size, color }) => {
  return (
    <AiOutlineLoading3Quarters
      color={color || 'white'}
      css={css`
        animation: ${spin} 1.5s linear infinite;
      `}
      size={size || '1em'}
    />
  );
};

export default SavingSpinner;
